import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonCol, IonGrid, IonNote, IonRow } from "@ionic/react";
import { useState } from "react";
import { useNamedRoutes } from "../NamedRoutes";
import { useFetchSystemList } from "../ReactData/system";
import SettingsTextInput from "../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";

const SystemSelect = () =>
{
    const { translate: t } = useL10n();
    const { generate, router } = useNamedRoutes();
    const findSystem = useFetchSystemList();
    const [systemNumber, setSystemNumber] = useState("");
    const [hasValue, setHasValue] = useState<boolean>(false);
    const [error, setError] = useState("");

    return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <IonGrid className="ion-padding">
            <IonRow>
                <IonCol>
                    <SettingsTextInput
                        id="system-number"
                        text="[REACT_ENTER_SYSTEM_NUMBER]"
                        value={systemNumber}
                        onKeyDown={() => setHasValue(false)}
                        onChange={(systemNumber) =>
                        {
                            setHasValue(true);
                            setSystemNumber(systemNumber.trim());
                        }}
                    />
                </IonCol>
                <IonCol style={{ display: 'flex', flexDirection: "column", alignItems: "end", justifyContent: "end" }}>
                    <IonButton
                        color={"success"}
                        disabled={!hasValue}
                        onClick={async () =>
                        {
                            const { results: systems } = await findSystem({ systemNumber, pageSize: 2 });

                            if (!systems || systems.length !== 1 || parseInt(systems[0].systemNumber as unknown as string) !== parseInt(systemNumber)) {
                                setError(t("[REACT_COULD_NOT_FIND_SYSTEM_WITH_SYSTEM_NUMBER]", { systemNumber }));
                            } else {
                                const system = systems[0];
                                const route = generate("system:events", { id: system.id! });
                                setError("");
                                router?.push(route);
                            }

                        }}
                    >
                        <span> {t('COM_FACPMANAGEMENT_SYSTEMS_OPERATE_SYSTEM')}</span>
                    </IonButton>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol><IonNote color="danger">{error}</IonNote></IonCol>
            </IonRow>
        </IonGrid>
    </div>;
};

export default SystemSelect;